import React from 'react';
import styles from './ProductOffers.module.scss';
import { ReactComponent as DeliveryTimeIcon } from '../../images/icons/delivery-time.svg';
import { ReactComponent as DeliveryCostIcon } from '../../images/icons/delivery-costs.svg';
import { ReactComponent as ArrowRight } from '../../images/icons/arrowRight.svg';
import Price from '../Price/Price';
import Rating from '../Rating/Rating';
import { FormattedMessage } from 'react-intl';
import getCDNImage from '../../utils/getCDNImage';
import clickoutScript from '../../utils/clickoutScript';
import Button from '../Button/Button';
import { getCloudinaryImage } from '../../utils/getCloudinaryImage';
import { Link } from 'react-router-dom';

const GenericOffer = ({
  ShopWrapper,
  shopLink,
  pdpLink,
  shopLogo,
  shopName,
  shopRating,
  deliveryTime,
  deliveryCosts,
  currency,
  price,
  url,
  clickout,
}) => {
  return (
    <div className={styles.offer}>
      <Link
        to={pdpLink}
        className={styles.shopLogo}
        link={shopLink}
        aria-label={`Go to ${shopName} product page`}
        title={`Go to ${shopName} product page`}
      >
        <img src={getCloudinaryImage(getCDNImage(shopLogo), 160, 70)} alt={`${shopName} logo`} />
      </Link>
      <ShopWrapper className={styles.shopInfo} link={shopLink}>
        <div className={styles.shopName}>{shopName}</div>
        <div className={styles.shopRating}>
          <Rating value={shopRating} />
        </div>
      </ShopWrapper>
      {/* <div className={styles.trustmark}>
        <img src={getCDNImage(shopLogo)} />
      </div> */}
      <div className={styles.delivery}>
        <div className={styles.deliveryTime}>
          <DeliveryTimeIcon /> {deliveryTime}
        </div>
        <div className={styles.deliveryPrice}>
          <DeliveryCostIcon />
          {deliveryCosts === 0 && <FormattedMessage id="product.freeDelivery" default="Free delivery" />}
          {deliveryCosts === null && <FormattedMessage id="common.unknown" default="Unknown" />}
          {deliveryCosts > 0 && <Price currency={currency} price={deliveryCosts} />}
        </div>
      </div>
      <div className={styles.price}>
        <Price currency={currency} price={price} />
      </div>
      <action className={styles.action}>
        <a
          onClick={() => clickoutScript(url, clickout, false)}
          href={clickoutScript(url, clickout, true)}
          rel="noopener noreferrer sponsored"
          target="_blank"
        >
          <Button variation="secondary">
            <FormattedMessage id="shop.goToShop" defaultMessage="Go to" /> <ArrowRight />
          </Button>
        </a>
      </action>
    </div>
  );
};

export default GenericOffer;
